export default "__VITE_ASSET__09a7f929__"